module.exports = "<header class=\"container-fluid\">\n    <div class=\"row bg-grey\">\n        <div class=\"col-xs-7 col-md-offset-5\">\n            <div class=\"btn-toolbar\" role=\"toolbar\">\n                <div class=\"btn-group\">\n                    <label class=\"btn btn-default\" ui-sref=\"create\" ng-model=\"$ctrl.radioModel\" uib-btn-radio=\"'Designer'\">Designer</label>\n                </div>\n            </div>\n        </div>\n    </div>\n</header>"


//////////////////
// WEBPACK FOOTER
// ./client/components/toolbar/toolbar.html
// module id = 21
// module chunks = 0